<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <div class="text-center">
        <img src="../assets/img/logobig.png" class="mt-2" style="max-width:90%"/>
        
        <br />
        <div class="container-box text-left">
          <CForm class="mt-3" autocomplete="chrome-off">
            <div v-if="this.Error == true" class="ml-1 mr-1">
              <CAlert show color="danger">{{ this.Message }}</CAlert>
            </div>

            <div v-if="this.ErrorExist == true" class="ml-1 mr-1">
              <CAlert show color="danger">User not exists</CAlert>
            </div>

            <br />
            <label style="text-align: left; left: 0" class="custom-label-note"
              >Enter Email</label
            >
            <input
              placeholder="Enter your email"
              v-model="Email"
              autocomplete="Email"
              class="custom-input-user"
              size="lg"
            />

            <br />
            <br />

            <label style="text-align: left; left: 0" class="custom-label-note"
              >Enter Password</label
            >
            <input
              placeholder="Enter your password"
              type="password"
              class="mb-2 custom-input-user"
              size="lg"
              autocomplete="off"
              v-model="Password"
              @keyup.enter="trylogin"
            />

            <CButton
              style="color: #fff"
              color="link"
              class="px-0"
              @click="GoToForgotPassword()"
              >Forgot Password ?</CButton
            >

            <CButton
              block
              class="mt-2 custom-btn-login-active"
              color="info"
              v-on:click="trylogin"
              >{{ labelBtn }}</CButton
            >
            <div class="text-center">
              <label
                style="text-decoration: underline; color: #fff"
                @click="GoToSignUp()"
                class="text-center mt-3"
                >I’m New, Sign Up Instead</label
              >
            </div>

            <!-- <CButton
                  color="success"
                  class="px-4"
                  @click="GoToSignUp()"
                  block
                  >SignUp</CButton
                > -->
          </CForm>
        </div>
      </div>
    </CContainer>
    <!-- <div class="outer-right">
      <img style="max-width: 350px" src="../assets/img/online.png" />
    </div> -->
  </div>
</template>

<script>
import backgroundUrl from "../assets/img/bgApps.png";

export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
      Email: "",
      Password: "",
      Error: false,
      Message: "",

      noteModal: true,

      backgroundUrl,
      labelBtn: "Login",
      user: {},
      ErrorExist: false,
      Error:false
    };
  },
  async mounted() {},
  methods: {
    GoToHome() {
      this.$router.push("/Dashboard");
    },
    trylogin() {
      this.labelBtn = "Processing";
      this.Error = false;

      const formData = new FormData();

      if (this.Email === "" || this.Password === "") {
        this.Error = true;
        this.Message = "Please fill up the form !";
      } else {
        formData.append("Email", this.Email);
        formData.append("Password", this.Password);

        this.$API
          .post(this.$LoginToken, formData, { withCredentials: true })
          .then((response) => {
            if (response.data.status === 400) {
              this.Loading = false;
              this.Message = response.data.message;
              this.Error = true;
            }
            if (response.status == 200) {
              if (response.data.status !== 400) {
                this.$API
                  .get(this.$GetCheckSubsLoginAdmin, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    if (response.status == 200) {
                      this.user = response.data;

                      if (this.user.validTo === 0) {
                        const formData = new FormData();

                        formData.append("userId", this.user.id);
                        formData.append("packageId", 1);

                        return this.$API
                          .post(this.$UpdatePaidSubscription, formData, {
                            withCredentials: true,
                          })
                          .then((response) => {
                            if (
                              response.status == 200 &&
                              response.data != null
                            ) {
                              //this.successModal = true;
                              // this.$dialog.alert(response.data).then(function () {});
                              this.GoToHome();
                            }
                          })
                          .catch((error) => {
                            if (error.response) {
                              console.log(error.response.status);
                              this.Error = true;
                              this.Message = error;
                              this.Message = "Error";
                            }
                          });
                      }
                      
                    }
                  });

                if (
                  this.$route.query.targetUrl != "" &&
                  (this.$route.query.targetUrl != null) &
                    (this.$route.query.targetUrl != undefined)
                ) {
                  this.$router.push(this.$route.query.targetUrl);
                } else {
                  this.GoToHome();
                }
              } else {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;
              }
            
            } else {
              this.Loading = false;
              this.Error = true;
              this.Message = response.data.message;
            }
          })
          .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
    GoToSignUp() {
      if (
        this.$route.query.targetUrl != "" &&
        (this.$route.query.targetUrl != null) &
          (this.$route.query.targetUrl != undefined)
      ) {
        let id = this.$route.query.targetUrl;
        var join = "codeId";
        var quiz = "quizId";
        let quizID = id.includes(quiz);
        let codeID = id.includes(join);

        console.log("test" + codeID);

        if (codeID == true) {
          let ids = this.$route.query.targetUrl;
          let code = ids.substr(ids.length - 26);

          console.log("test" + code);

          this.$router.push("/SignUp?codeId=" + code, "_self");
        }
        if (quizID == true) {
          let ids = this.$route.query.targetUrl;
          let quiz = ids.substr(ids.length - 26);
          this.$router.push("/SignUp?quizId=" + quiz, "_self");
        }
      } else {
        this.$router.push("SignUp");
      }
    },
    GoToForgotPassword() {
      this.$router.push("ForgotPassword");
    },
  },
};
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.container-box {
  max-width: 335px;
  margin: 0 auto;
}

input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
  -webkit-text-fill-color: white !important;
}
input .custom-user-input-select {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
}
.custom-width-listphone {
  width: 24px;
  height: 24px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

select {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #e0e0e0;
}

input ::placeholder {
  color: #fff;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
.custom-user-input-select {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
.custom-user-inputs {
  display: flex;
  display: -ms-flexbox;
  /* display: -webkit-box; */
  /* -webkit-box-pack: center; */
  -ms-flex-pack: center;
  justify-content: center;
  /* -webkit-box-orient: horizontal; */
  /* -webkit-box-direction: normal; */
  -ms-flex-flow: row nowrap;
  /* flex-flow: row nowrap; */
  width: -webkit-fill-available;
}
input:-webkit-autofill {
  -webkit-background-clip: text;
  -webkit-text-fill-color: white !important;
}

.custom-label-note {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  /* or 18px */

  text-align: center;

  /* White Solid AF */

  color: #ffffff;
}
</style>
